<div class="page-section">
    <div class="page-section-header">
        <h2 class="page-section-title">Agent Withdraw ({{status == 2 ? 'Pending Approval' : status == 1 ? 'Approved' : 'Rejected'}})</h2>
    </div>
    <div class="page-section-filters">
        <div class="btn-group btn-group-sm">
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 2" (click)="getRequests(2)">Pending</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 1" (click)="getRequests(1)">Approved</button>
            <button class="btn btn-outline-primary text-nowrap" [class.active]="status == 0" (click)="getRequests(0)">Rejected</button>
        </div>
    </div>
    <div class="page-section-body">
        <table class="table">
            <thead>
                <tr>
                    <th>No</th>
                    <th>Agent</th>
                    <th>Agent Name</th>
                    <th>Amount</th>
                    <th>Payout To</th>
                    <th *ngIf="status != 2">Type</th>
                    <th *ngIf="status == 1">Paid From</th>
                    <th *ngIf="status == 0">Reason</th>
                    <th *ngIf="status == 2">Decision</th>
                    <th *ngIf="status == 2">Pay From</th>
                    <th *ngIf="status == 2">Action</th>
                    <th>Date</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let request of requests; let i = index">
                    <td>{{i+1}}</td>
                    <td>{{request.player_code}} <span *ngIf="request.is_suspended == 1" class="badge bg-danger">Suspended</span></td>
                    <td>{{request.player_name}}</td>
                    <td>{{request.amount | number: '1.2-2'}}</td>
                    <td>
                        <ng-container *ngIf="request.payout_type == 'cash'"><span class="badge bg-warning text-dark">CASH</span></ng-container>
                        <ng-container *ngIf="request.payout_type != 'cash'">
                            <div>{{request.bank_name}}</div>
                            <div class="text-muted small">{{request.bank_account}}</div>
                            <div class="text-muted small" *ngIf="request.fullname">{{request.fullname}}</div>
                        </ng-container>
                    </td>
                    <td *ngIf="status != 2">{{request.payout_type == 'cash' ? 'Cash' : 'Bank'}}</td>
                    <td *ngIf="status == 1">{{request.payout_bank_title || '-'}}</td>
                    <td *ngIf="status == 0">{{request.remark}}</td>

                    <!-- Pending: approve / reject decision -->
                    <td *ngIf="status == 2">
                        <select class="form-select form-select-sm" [(ngModel)]="request.action_status">
                            <option [ngValue]="1">Approve</option>
                            <option [ngValue]="0">Reject</option>
                        </select>
                        <input *ngIf="request.action_status == 0" type="text" class="form-control form-control-sm mt-2" placeholder="Reason" [(ngModel)]="request.remark">
                    </td>

                    <!-- Pending: choose payout source bank / cash + proof -->
                    <td *ngIf="status == 2">
                        <ng-container *ngIf="request.action_status == 1">
                            <!-- Editable payout amount (cap = requested). Lets the admin
                                 drop the decimal so the agent is paid a whole number;
                                 the trimmed difference is refunded to agent_wallet. -->
                            <div class="mb-2" *ngIf="allow_edit_balance">
                                <label class="form-label small mb-1">Payout Amount (max {{request.max_amount | number: '1.2-2'}})</label>
                                <div class="input-group input-group-sm">
                                    <input type="number" class="form-control form-control-sm" [(ngModel)]="request.amount" (blur)="clampAmount(request)" min="0" [max]="request.max_amount" step="0.01">
                                    <button class="btn btn-outline-secondary" type="button" (click)="trimAmount(request)" title="Drop the decimal (round down)">.00</button>
                                </div>
                            </div>
                            <select class="form-select form-select-sm mb-2" [(ngModel)]="request.payout_type">
                                <option value="bank">Bank Transfer</option>
                                <option value="cash">Cash Payout</option>
                            </select>
                            <ng-container *ngIf="request.payout_type == 'bank'">
                                <select class="form-select form-select-sm" [(ngModel)]="request.bank_id" (change)="changeBank(request)">
                                    <option [ngValue]="undefined" disabled>Select bank to pay from</option>
                                    <option *ngFor="let bank of banks" [ngValue]="bank.id">{{bank.title}} - {{bank.payee}} - {{bank.account}} {{bank.auto ? '(Auto)' : '(Manual)'}}</option>
                                </select>
                                <div class="mt-2" *ngIf="request.bank_id">
                                    <label class="form-label small mb-1">Upload Proof (optional)</label>
                                    <input type="file" accept="image/*" class="form-control form-control-sm" (change)="uploadFile($event, request)">
                                    <img src="{{request.file}}" class="img-fluid mt-1" *ngIf="request.file">
                                </div>
                            </ng-container>
                        </ng-container>
                    </td>

                    <td *ngIf="status == 2">
                        <button class="btn btn-primary btn-sm" [disabled]="request._submitting || request.is_suspended == 1" (click)="updateRequest(request)">{{ request._submitting ? 'PROCESSING...' : 'UPDATE' }}</button>
                    </td>
                    <td>{{request.create_on | date:'dd/MM/yyyy HH:mm'}}</td>
                </tr>
                <tr *ngIf="requests.length == 0 && !is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">No data found</td>
                </tr>
                <tr *ngIf="is_loading">
                    <td colspan="100%" class="text-center text-muted py-4" style="font-style: italic;">Loading...</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="page-section-footer" *ngIf="!is_loading && requests.length > 0">
        <span>Total Requests:</span>
        <span class="page-section-stat">{{requests.length}}</span>
    </div>
</div>
